import { Component, Type, viewChild } from '@angular/core';

import { SideBarDirective } from './side-bar.directive';
import { SideBarService } from './side-bar.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'side-bar',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    SideBarDirective
  ],
  templateUrl: './side-bar.component.html'
})
// Uses Dynamic Component Loader See https://angular.io/guide/dynamic-component-loader
export class SideBarComponent {
  sideBarHost = viewChild.required(SideBarDirective);

  constructor(sideBarService: SideBarService) {
    sideBarService.sideBarComponentLoad$.subscribe(({ type, data })  => this.openSideBar(type, data));
  }

  loadComponent(type: Type<unknown>, data: unknown) {
    const viewContainerRef = this.sideBarHost().viewContainerRef;

    viewContainerRef.clear();

    const component = viewContainerRef.createComponent(type);
    (component.instance as Record<string, unknown>)["data"] = data;
  }

  openSideBar(type: Type<unknown>, data: unknown) {
    this.loadComponent(type, data);
  }
}
